const updatePaymentProfile = (state, action) => {
  if (state === undefined) {
    return {
      profiles: [],
      loading: true,
    };
  }

  switch (action.type) {
    case "PAYMENT_PROFILES_REQUESTED":
      return {
        ...state.paymentProfile,
        loading: true,
      };
    case "PAYMENT_PROFILES_LOADED":
      return {
        ...state.paymentProfile,
        loading: false,
        profiles: action.payload,
      };
    case "PAYMENT_PROFILES_LOADING":
      return {
        ...state.paymentProfile,
        loading: action.payload,
      };
    default:
      return state.paymentProfile;
  }
};

export default updatePaymentProfile;
